export class PaypalReturnModel {
	success: boolean;
	errorMessage: string;
}
